import { WhiteBoxBase } from "@jog/theming";
export const WhiteBox = WhiteBoxBase({ defaultPadding: "40px 56px" });
